import { Box } from '@mui/material';
import { Control, FieldPath } from 'react-hook-form';
import { LwFormMultiSelect } from 'redesign';
import type { EnrollNodeFormValues, EntityOption } from '../../enroll-node-editor.types';

type EnrollEntityIdsFieldProps = {
  control: Control<EnrollNodeFormValues>;
  name: FieldPath<EnrollNodeFormValues>;
  label: string;
  options: EntityOption[];
  disabled?: boolean;
};

export const EnrollEntityIdsField = ({
  control,
  name,
  label,
  options,
  disabled,
}: EnrollEntityIdsFieldProps) => {
  return (
    <Box>
      <LwFormMultiSelect<EntityOption, EnrollNodeFormValues>
        name={name}
        control={control}
        label={label}
        options={options}
        disabled={disabled}
        getOptionLabel={(o) => o.label}
        getOptionKey={(o) => o.value}
        isOptionEqualToValue={(a, b) => a.value === b.value}
        enableSelectAll={true}
        rules={{
          required: true,
          validate: (v: unknown) =>
            Array.isArray(v) && v.length > 0 ? true : 'Entity is required',
        }}
      />
    </Box>
  );
};
